<% var component = new Anvil.models.components.Switch(field) %>
<% if ('inline' in field && field.inline) { %>
<div anvil-component="<%- component.id %>" class="col<%- ('width' in field) ? `-${field.width}` : '' %>">
	<div class="form-check form-switch">
		<input type="checkbox" class="form-check-input" id="<%= form.name %>_<%= field.name %>" name="<%= field.name %>" value="1" <% if (form.data[field.name] == ('values' in field ? field.values[1] : 1)) { %>checked<% } %> <% if ('attributes' in field) for (let key in field.attributes) { %><%- key %>="<%- field.attributes[key] %>" <% } %> />
		<label class="form-check-label" for="<%= form.name %>_<%= field.name %>"><%- field.description %></label>
	</div>
</div>
<% } else { %>
<div anvil-component="<%- component.id %>" class="form-group row">
	<div class="col-<%= ('label_width' in form.params) ? form.params.label_width : '4' %>">
		<label for="<%= form.name %>_<%= field.name %>" class="control-label"><%- field.title %></label>
	</div>
	<div class="col">
		<div class="form-check form-switch">
			<input type="checkbox" class="form-check-input" id="<%= form.name %>_<%= field.name %>" name="<%= field.name %>" value="1" <% if (form.data[field.name] == ('values' in field ? field.values[1] : 1)) { %>checked<% } %> <% if ('attributes' in field) for (let key in field.attributes) { %><%- key %>="<%- field.attributes[key] %>" <% } %> />
			<label class="form-check-label" for="<%= form.name %>_<%= field.name %>"><%- field.description %></label>
		</div>
		<% if ('help' in field) { %><small class="form-text text-muted"><%- field.help %></small><% } %>
		<div class="invalid-feedback"></div>
	</div>
</div>
<% } %>